import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DashboardAvanzadoClaude from './DashboardAvanzadoClaude';
import '../styles/dashboard-avanzado.css';

const DashboardAvanzado = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.rol !== 'JEFE') {
      navigate('/expedientes', { replace: true });
    }
  }, [user, navigate]);

  if (!user || user.rol !== 'JEFE') {
    return null;
  }

  return <DashboardAvanzadoClaude />;
};

export default DashboardAvanzado;
